import React from 'react';
import Skeleton from 'components/LoadingSkeleton';

interface TopNavSkeletonProps {
  shouldHideNavigation: boolean;
}

const TopNavSkeleton: React.FC<TopNavSkeletonProps> = ({ shouldHideNavigation }) => {
  return (
    <div className="absolute left-0 right-0 mx-auto flex h-full w-full items-center justify-center ">
      <div className="h-12 flex-row gap-3 rounded-full border border-color-border-input-lightmode shadow-sm dark:border-color-border-input-darkmode xs:hidden md:flex ">
        {!shouldHideNavigation && (
          <div className="mx-3 hidden h-full items-center xs:gap-0 md:flex lg:gap-3">
            <div className="px-ds-lg py-2">
              <Skeleton width={60} height={20} />
            </div>
            <div className="px-ds-lg py-2">
              <Skeleton width={70} height={20} />
            </div>
            <div className="px-ds-lg py-2">
              <Skeleton width={60} height={20} />
            </div>
            <div className="px-ds-lg py-2">
              <Skeleton width={50} height={20} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopNavSkeleton;
